import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'rebass/styled-components';
import styled from 'styled-components';
import theme from 'styled-theming';
import { ReactComponent as IconChecked } from '../assets/icon-checkbox.svg';

const checkboxBorderColor = theme('mode', {
  light: (props) => props.theme.colors.greyLight,
  dark: (props) => props.theme.colors.isabelline,
});

const checkboxColor = theme('mode', {
  light: (props) => props.theme.colors.whiteGrey,
  dark: (props) => props.theme.colors.deepGrey,
});

const activeBorderColor = theme('mode', {
  light: (props) => props.theme.colors.periwinkle,
  dark: (props) => props.theme.colors.brightCerulean,
});

const Icon = styled(IconChecked)`
  fill: none;
  stroke: ${checkboxColor};
  stroke-width: 2px;
`;

const StyledCheckbox = styled(Flex)`
  ${Icon} {
    visibility: ${(props) => (props.checked ? 'visible' : 'hidden')}
  }
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  min-width: 16px;
  height: 16px;
  border: 2px solid ${checkboxBorderColor};
  border-color: ${(props) => (props.checked ? activeBorderColor : checkboxBorderColor)};
  border-radius: 2px;
  transition: all 150ms;
  background-color: ${(props) => (props.checked ? activeBorderColor : 'transparent')};
  box-sizing: border-box;
  z-index: 10;
  cursor: pointer;
  transition: .2s all;
`;

const Checkbox = ({
  className,
  checked,
  onChange,
  ...props
}) => (
  <StyledCheckbox
    checked={checked}
    className={className}
    onClick={onChange}
  >
    <Icon viewBox="0 0 8 7">
      <IconChecked />
    </Icon>
  </StyledCheckbox>
);

Checkbox.defaultProps = {
  className: '',
};

Checkbox.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};
export default Checkbox;
